module.exports = __webpack_public_path__ + "static/media/patientStats.207035ce.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/docs/assets/patientStats.PNG
// module id = 265
// module chunks = 0